import React, { useContext } from 'react';
import { ViewDashboardContext } from '../../shared/entities/view/components/view-dashboard/ViewDashboardContext';
import { ResearchDashboardDto } from '../interfaces/ResearchDashboardDto';
import ViewDashboardGrid from '../../shared/entities/view/components/view-dashboard/components/ViewDashboardGrid';
import { ResearchDashboardProp } from '../enums/ResearchDashboardProp';
import { recentResearchViewOptions } from '../../views/recent-research/constants/recentResearchViewOptions';
import { researchGridCustomColumnsSettings } from '../constants/researchGridCustomColumnsSettings';

const ResearchDashboardEnhancedProfilesGrid: React.FC = () => {
  const context = useContext(ViewDashboardContext);
  const data = context.data as ResearchDashboardDto;

  return (
    <ViewDashboardGrid
      dataTable={data[ResearchDashboardProp.RecentlyEnhancedProfiles]}
      colIds={recentResearchViewOptions.grid?.idCols}
      customColumnsSettings={researchGridCustomColumnsSettings}
    />
  );
};

export default ResearchDashboardEnhancedProfilesGrid;
